import { stateWord } from './serverMods';

/**
 * A server's state as a tag, like the app's other status chips (a dot and the
 * text): green while it runs, with how long it has been up, quiet while it is
 * stopped. The owner preferred the tag to a bare word (test card 126,
 * 2026-10-13).
 */
export function ServerStateTag({ alive, uptime }: { alive: boolean; uptime: string | null }) {
  return (
    <span className={`chip server-state ${alive ? 'on ok' : 'off'}`}>
      <span className={`dot ${alive ? 'ok' : 'off'}`} aria-hidden="true" />
      {stateWord(alive, uptime)}
    </span>
  );
}
